// extracted by mini-css-extract-plugin
export default {"root":"SharePannel_root__+OmfP","rootIsOpened":"SharePannel_rootIsOpened__kzobJ","item":"SharePannel_item__A0qWA","icon":"SharePannel_icon__U1ft-"};